module.exports = (
  $scope,
  $state,
  Api,
  User,
  alerts,
  endpoints
) ->
  $scope.alerts = alerts
  $scope.filters =
    tag: null

  #
  # View
  #

  $scope.showTypeColumn = (subject) ->
    $scope.isSource(subject, 'anansi') || $scope.isSource(subject, 'world_compliance')

  $scope.isSource = (subject, targetSource) ->
    source = subject.source or User.d3_alerts_data_source
    source?.indexOf(targetSource) == 0

  $scope.showDOBColumn = (subject) ->
    subject.type == 'individual'

  $scope.showMatchingScoreColumn = (results) ->
    results.length > 0 and results[0].data['Matching Score']?

  $scope.getEntryTypeIcon = (alert) ->
    # Entry Type is currently only used by world_compliance, thus there'll be no icon for other data sources
    typeToIcon =
      individual: 'glyphicons-user'
      organization: 'glyphicons-building'
    typeToIcon[alert.data['Entry Type']?.toLowerCase()] or ''

  $scope.getCategory = (alert) ->
    return alert.data['Hit Subcategory'] if alert.data['Hit Subcategory']? && alert.data['Hit Subcategory'] != 'N/A'
    return alert.data['Hit Category']

  $scope.getAlertURL = (alert) ->
    endpoints.MonitoringSubjects + alert.subject + '/alerts/' + alert.id + '/alerturl/'

  $scope.getPDFURL = (alert) ->
    endpoints.MonitoringSubjects + alert.subject + '/alerts/' + alert.id + '/alertpdf/'

  #
  # Pagination
  #

  $scope.loadData = (params) ->
    req = new Api.MonitoringSubjectAlerts.get(params).$promise
    $scope.loading = true
    req.then (alerts) ->
      $scope.alerts = alerts
      $scope.loading = false

  $scope.loadPage = (page) ->
    $scope.offset = ((page or 1) - 1) * 10
    params =
      offset: $scope.offset
      limit: 10
      subject: $scope.subject.id

    if $scope.filters.tag?
      params.tags = $scope.filters.tag?.id
    else
      params.outstanding_only = true

    $scope.loadData params
